<template>
  <div
    class="image__wrapper"
    :class="{'loaded': !loading }"
    @click="openImageViewer"
  >
    <img
      class="image__item"
      :src="source"
      :style="{ width: imageWidth }"
    />
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/events/eventBus";
import errorHandler from "@/mixins/errorHandler";

export default {
  name: "ImageItem",
  mixins: [errorHandler],
  props: {
    attachmentId: {
      type: String,
      required: true
    },
    attachment: {
      type: Object,
      required: true,
    },
    imageWidth: {
      type: String,
      default: "100%",
    },
    processed: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters("user", ["currentToken"]),
    ...mapState({
      imageAttachmentThumbnail: state => state.attachment.imageAttachmentThumbnail
    }),
  },
  data() {
    return {
      loading: false,
      source: "/images/image-placeholder-180.png",
      fetchAbortController: null,
    };
  },
  methods: {
    openImageViewer() {
      EventBus.$emit("openImageViewerModal", {
        currentAttachmentId: this.attachmentId
      });
    },
    async loadImage() {
      try {
        this.loading = true;
        const thumbnails = this.imageAttachmentThumbnail[this.$route.params.conversationId];

        if (thumbnails && thumbnails[this.attachmentId]) {
          this.source = thumbnails[this.attachmentId];
          this.loading = false;
        } else {
          this.fetchAbortController = new AbortController();
          const headers = {
            "Authorization": `Bearer ${this.currentToken}`
          };

          const fetchImageUrl = this.attachment.thumbnail
            ? `${this.$apihost}/attachments/${this.attachmentId}/download?thumbnail=1&stream=1`
            : `${this.$apihost}/attachments/${this.attachmentId}/download?stream=1`;

          const res = await axios.get(
            fetchImageUrl,
            {
              headers,
              responseType: "blob",
              signal: this.fetchAbortController.signal,
            }
          );
          this.source = URL.createObjectURL(res.data);
          this.$store.commit("attachment/setImageAttachmentThumbnail", {
            conversationId: this.$route.params.conversationId,
            attachmentId: this.attachmentId,
            source: this.source,
          });
        }
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[ImageItem:loadImage] ERROR: ", err);
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    processed: {
      handler(status) {
        if (status) {
          this.loadImage();
        }
      },
      immediate: true,
    }
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  }
};
</script>

<style scoped>
.image__wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
  cursor: pointer;
}
.image__wrapper.loaded .image__item {
	visibility: visible;
	opacity: 1;
	border: 0;
}
.image__item {
	border-radius: 4px;
	transition: all 0.4s ease-in-out;
	opacity: 0;
	visibility: hidden;
}
</style>
